// extracted by mini-css-extract-plugin
export var defaultWrapper = "_j2-3";
export var downloadButton = "_j2-4";
export var fileContainer = "_j2-9 _j2-7";
export var fileContainerBase = "_j2-7";
export var fileContainerFixedHeight = "_j2-8 _j2-7";
export var fileInfo = "_j2-5";
export var fileInfoWidthRestricted = "_j2-6";
export var fileType = "_j2-1";
export var fileTypeName = "_j2-2";
export var image = "_j2-0";
export var link = "_j2-b";
export var overflowEllipsis = "_j2-a";